import React from 'react';
import { createMemoryRouter } from 'react-router-dom';

import { ArticleSidebar } from '../../help-center/components/ArticleSidebar';
import { AppRoutePatterns } from '../appRoutes';
import { ContactAppLayout } from '../components';

export const contactAppRouter = createMemoryRouter([
  {
    path: '/',
    element: <ContactAppLayout />,
    children: [
      {
        path: AppRoutePatterns.ArticleById,
        element: <ArticleSidebar />,
      },
      {
        path: AppRoutePatterns.ArticleByUri,
        element: <ArticleSidebar />,
      },
      {
        path: '*',
        element: null,
      },
    ],
  },
]);
